import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearMappingBackUrl} from "../config/crystalclear-mapping-back-url";
import {SrcMappingAccountCode} from "../../model/mapping/src-mapping-account-code";
import {SrcMappingBrokerCode} from "../../model/mapping/src-mapping-broker-code";
import {SrcMappingFee} from "../../model/mapping/src-mapping-fee";
import {SrcMappingContract} from "../../model/mapping/src-mapping-contract";
import {SrcMappingExchange} from "../../model/mapping/src-mapping-exchange";
import {SrcMappingTrader} from "../../model/mapping/src-mapping-trader";

@Injectable({
  providedIn: 'root'
})
export class MappingSrcMappingTraderService extends CommonCrudService<SrcMappingTrader> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearMappingBackUrl.GET_MAPPING_SRCMAPPINGTRADER_LIST,
      CrystalclearMappingBackUrl.SAVE_MAPPING_SRCMAPPINGTRADER,
      CrystalclearMappingBackUrl.DELETE_MAPPING_SRCMAPPINGTRADER);
  }

}
